import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { TenantService } from '@core/services';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export const reportsEnabledGuardFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  return inject(ReportsEnabledGuard).canActivate(route, state);
};

@Injectable({
  providedIn: 'root',
})
export class ReportsEnabledGuard {
  constructor(
    private readonly tenantService: TenantService,
    private readonly cookieService: CookieService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const tenantId = JSON.parse(this.cookieService.get('currentUser')).tenantId;
    return this.tenantService.getSettings(tenantId).pipe(
      map((response: any) => {
        if (response?.features?.DynamicReports) {
          return true;
        }
        return this.router.createUrlTree(['/reports']);
      })
    );
  }
}
